import { render, staticRenderFns } from "./CustomerConfirm.vue?vue&type=template&id=787350cc"
import script from "./CustomerConfirm.vue?vue&type=script&lang=js"
export * from "./CustomerConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports